<template>
  <div class="certificate">
    <img src="./img/certificate1.jpeg" alt="" />
  </div>
</template>

<script>
export default {
  name: "about",

  data() {
    return {};
  },

  beforeDestroy() {},
  created() {},

  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.certificate {
  margin-top: 0.7rem;
  display: flex;
  justify-content: center;
  img {
    width: 50%;
  }
}
</style>
